'use client';

import React from 'react';

import { useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';

import BackIcon from '@/assets/icons/back.svg';
import { P } from '@/components/shared/Typography';
import { Button } from '@/components/ui/button';

function ProfileInformationNav() {
  const router = useRouter();
  const t = useTranslations('editProfile');

  const backHandle = () => {
    router.back();
  };

  return (
    <div className="flex items-center gap-2">
      <Button
        onClick={backHandle}
        variant={'outline'}
        icon={<BackIcon />}
      ></Button>
      <P className="justify-center flex-1 text-2xl font-semibold leading-loose pr-6">
        {t('profileInformation')}
      </P>
    </div>
  );
}

export default ProfileInformationNav;
